import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import "./style.css"
import { height } from "@mui/system"
import DownloadCalendar from "./subscribe_events"

const RSVPSection = ({ guestName = "Guest Name" }) => {
  guestName = guestName?.replace(/_/g, ' ');
  return (
    <div id="rsvp" className="py-2 elegant-background" style={{height: "max-content !important"}}>
      <Container className="py-5">
        <div className="elegant-border">
          <Row className="justify-content-center">
            <Col xs={12} className="text-center section-title position-relative">
              <h1 className="mb-3 display-4 great-vibes text-gold">શુભ નમસ્કાર</h1>
              <h6 id="guest-name-main-page" className="guest-name text-maroon">
                {(guestName===undefined)? "" :`શ્રી ${guestName}` }
              </h6>
              <h1 className="display-5 great-vibes text-dark-gold" style={{ letterSpacing: "2px", fontWeight: 100 }}>
                ઝાલા પરિવારના આંગણે આવા ઉજળા અવસરે અમારા લગ્નમાં જરૂરથી પધારશોજી. તમારા આશીર્વાદ અને ઉપસ્થિતિ અમારા શુભ પ્રસંગની
                શોભા વધારશે.
              </h1>
              <div className="decorative-element"></div>
            </Col>
            <DownloadCalendar />

          </Row>
        </div>
      </Container>
    </div>
  )
}

export default RSVPSection

